import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  showSpinner: false,
  showInnerSpinner: false,
  showModalSpinner: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    showSpinner(state) {
      state.showSpinner = true;
    },
    hideSpinner(state) {
      state.showSpinner = false;
    },
    showInnerSpinner(state) {
      state.showInnerSpinner = true;
    },
    hideInnerSpinner(state) {
      state.showInnerSpinner = false;
    },
    showModalSpinner(state) {
      state.showModalSpinner = true;
    },
    hideModalSpinner(state) {
      state.showModalSpinner = false;
    },
  }
});

export const selectShowSpinner = (state) => state.ui.showSpinner;
export const selectShowInnerSpinner = (state) => state.ui.showInnerSpinner;
export const selectShowModalSpinner = (state) => state.ui.showModalSpinner;

export const uiActions = uiSlice.actions;

export default uiSlice;